import React from 'react';
import { createStructuredSelector } from 'reselect';
import { AppState } from 'services/types';
import { connect } from 'react-redux';

import WarningMessage from 'components/WarningMessage';
import { Grid } from 'semantic-ui-react';
import { makeSelectEntitiesWithMissingFertilizerSettings } from './selectors';
import { EntityDropdownOptions } from '../../types';

interface ConnectedProps {
    entities: string[];
}

export interface OwnProps {
    options: EntityDropdownOptions;
}

export type Props = OwnProps & ConnectedProps;

export class FertilizerSchemaInnerEntityTableFieldWarningComponent extends React.PureComponent<Props> {
    render(): React.ReactElement | null {
        const { entities } = this.props;

        if (entities && entities.length) {
            const content = (
                <div style={{ whiteSpace: 'break-spaces' }}>
                    {entities.join('\n')}
                </div>
            );

            const title =
                entities.length > 1
                    ? 'Some areas could not be displayed as they are missing total area (required fields for fertilizer):'
                    : 'One area could not be displayed as it is missing total area (required fields for fertilizer):';

            return (
                <Grid.Row>
                    <Grid.Column>
                        <WarningMessage
                            title={title}
                            content={content}
                            visible
                        />
                    </Grid.Column>
                </Grid.Row>
            );
        }

        return null;
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    entities: makeSelectEntitiesWithMissingFertilizerSettings()
});

export default connect(mapStateToProps)(
    FertilizerSchemaInnerEntityTableFieldWarningComponent
);
